import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";

// #202-T4: Attachment-Cleanup-Mutations (admin-only auf dem Master).
function useAttachmentsClient() {
  const { session, logout } = useAuth();
  return () =>
    createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
}

function useInvalidateAttachments() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: queryKeys.resource("attachments") });
}

export function useDeleteAttachment(): UseMutationResult<void, Error, string> {
  const getClient = useAttachmentsClient();
  const invalidate = useInvalidateAttachments();
  return useMutation({
    mutationFn: (id) => getClient().delete<void>(`/attachments/${id}`),
    onSuccess: invalidate,
  });
}

export function useBulkDeleteAttachments(): UseMutationResult<{ deleted: number }, Error, string[]> {
  const getClient = useAttachmentsClient();
  const invalidate = useInvalidateAttachments();
  return useMutation({
    mutationFn: (ids) => getClient().post<{ deleted: number }>(`/attachments/bulk-delete`, { ids }),
    onSuccess: invalidate,
  });
}
